var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnitySessionRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "session_remote") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 8h-4v-1.898c0.302-0.274 0.5-0.661 0.5-1.102 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.441 0.198 0.827 0.5 1.102v1.898h-18v16h9.429l-3.429 4h12l-3.429-4h9.429v-16zM26 22h-20v-12h20v12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitySessionRemote);
export default __webpack_public_path__ + "static/media/unity_session_remote.fb3899d09b7dc87f1b8f384e3b047acd.svg";
export { ForwardRef as ReactComponent };